import { BaseServiceImpl } from "./BaseServiceImpl";
import { ResponseMessage } from "../domain/enums/common/ResponseMessageEnum";

export class GoogleAuthServiceImpl extends BaseServiceImpl {
    async loginWithGoogle(token: string): Promise<ResponseMessage | undefined> {
        try {
            return await this.post<ResponseMessage>("/api/v1/google-login", {
                token,
            });
        } catch (err) {
            console.log("GoogleAuthServiceImpl.loginWithGoogle => ERROR:");
            console.log(err);
        }
    }
}

export function googleAuthServiceFactory(): GoogleAuthServiceImpl {
    return new GoogleAuthServiceImpl();
}
